module.exports = __webpack_public_path__ + "static/media/emilyz.9fcf69e5.jpg";